import { withEntryAppLayout } from "../services/pages.layout";
import { Navigate } from "react-router-dom";
import { withDashboardLayout as withEtablissementDashboardLayout } from "../pages/etablissement/dashboard/DashboardLayout";
import MedicalMaps from "../pages/maps/MedicalMaps";



// import HomePage from "../pages/HomePage";



import EntryInApp from "../pages/EntryInApp";
import AgbazaLegalDocPage from "../pages/legal/AgbazaLegalDocPage";
import MinistryLogin from "../pages/ministry/Login";
import MinistryDashboard from "../pages/ministry/Dashboard";
import MinistryCommunique from "../pages/ministry/Communique";
import PatientLogin from "../pages/patient/Login";
import PatientLoginCode from "../pages/patient/LoginCode";
import PatientSignup from "../pages/patient/Signup";
import PatientSignupCode from "../pages/patient/SignupCode";
import PatientHome from "../pages/patient/Home";
import PatientConsultations from "../pages/patient/Consultations";
import PatientMedicalFile from "../pages/patient/MedicalFile";
import PatientPrescriptions from "../pages/patient/Prescriptions";
import PatientVaccinations from "../pages/patient/Vaccinations";
import PatientMonEspaceSante from "../pages/patient/MonEspaceSante";
import PatientIdentityVerification from "../pages/patient/IdentityVerification";
import PatientAjouterEnfant from "../pages/patient/AjouterEnfant";
import PatientContactsSurete from "../pages/patient/ContactsSurete";
import ConfirmerContactSurete from "../pages/patient/ConfirmerContactSurete";
import ProLogin from "../pages/professional/Login";
import ProForgotPassword from "../pages/professional/ForgotPassword";
import ProVerificationCode from "../pages/professional/Code";
import ProNewPassword from "../pages/professional/NewPassword";
import ProSignupInfo1 from "../pages/professional/signup/Info1";
import ProSignupInfo2 from "../pages/professional/signup/Info2";
import ProSignupCredentials from "../pages/professional/signup/Credentials";
import ProSignupEtablissements from "../pages/professional/signup/Etablissements";
import ProSignupDocument from "../pages/professional/signup/Document";
import ProSignupSuccess from "../pages/professional/signup/Success";
import ProDashboardLayout from "../pages/professional/dashboard/ProDashboardLayout";
import ProPatients from "../pages/professional/dashboard/Patients";
import ProPatientDetail from "../pages/professional/dashboard/PatientDetail";
import ProQuickDiagnostic from "../pages/professional/dashboard/QuickDiagnostic";
import ProProfile from "../pages/professional/dashboard/Profile";
import ProMonActivite from "../pages/professional/dashboard/MonActivite";
import ProMesConsultationsAssignees from "../pages/professional/dashboard/MesConsultationsAssignees";
import ProIdentityVerification from "../pages/professional/dashboard/IdentityVerification";
import { withPatientDashboardLayout } from "../pages/patient/dashboard/PatientDashboardLayout";
import EtablissementLogin from "../pages/etablissement/Login";
import EtablissementLoginCode from "../pages/etablissement/LoginCode";
import EtablissementForgotPassword from "../pages/etablissement/ForgotPassword";
import EtablissementCode from "../pages/etablissement/Code";
import EtablissementNewPassword from "../pages/etablissement/NewPassword";
import EtablissementSignupSearch from "../pages/etablissement/signup/Search";
import EtablissementSignupInfo from "../pages/etablissement/signup/Info";
import EtablissementSignupCredentials from "../pages/etablissement/signup/Credentials";
import EtablissementSignupDocuments from "../pages/etablissement/signup/Documents";
import EtablissementSignupSuccess from "../pages/etablissement/signup/Success";
import EtablissementBeds from "../pages/etablissement/dashboard/Beds";
import EtablissementBlood from "../pages/etablissement/dashboard/Blood";
import EtablissementProducts from "../pages/etablissement/dashboard/Products";
import EtablissementPatients from "../pages/etablissement/dashboard/Patients";
import EtablissementPatientDetail from "../pages/etablissement/dashboard/PatientDetail";
import EtablissementAddPatient from "../pages/etablissement/dashboard/AddPatient";
import EtablissementStatistiques from "../pages/etablissement/dashboard/Statistiques";
import EtablissementPersonnel from "../pages/etablissement/dashboard/Personnel";
import EtablissementConsultations from "../pages/etablissement/dashboard/Consultations";
import EtablissementIdentityVerification from "../pages/etablissement/dashboard/IdentityVerification";
import RequireAuthEtablissement from "../components/RequireAuthEtablissement";
import RequireAuthProfessional from "../components/RequireAuthProfessional";
import RequireAuthPatient from "../components/RequireAuthPatient";
import DocumentVerificationPage from "../pages/verify/DocumentVerificationPage";
interface RouteConfig {
  path: string;
  element: JSX.Element;
}

const routesConfig: RouteConfig[] = [
  { path: "/", element: withEntryAppLayout(<EntryInApp />) },
  { path: "/app-entry", element: withEntryAppLayout(<EntryInApp />) },

  // Vérification publique de documents (QR code)
  { path: "/consultation/:id", element: <DocumentVerificationPage /> },
  { path: "/ordonnance/:id", element: <DocumentVerificationPage /> },
  {
    path: "/privacy-policy",
    element: withEntryAppLayout(<AgbazaLegalDocPage />),
  },
  {
    path: "/cookies-policy",
    element: withEntryAppLayout(<AgbazaLegalDocPage />),
  },

  // { path: "/accueil", element: withGeneralLayout(<HomePage />) },

  { path: "/medical-maps", element: <MedicalMaps /> },

  { path: "/patient/connexion", element: <PatientLogin /> },
  { path: "/patient/connexion/code", element: <PatientLoginCode /> },
  { path: "/patient/inscription", element: <PatientSignup /> },
  { path: "/patient/inscription/code", element: <PatientSignupCode /> },
  {
    path: "/patient",
    element: (
      <RequireAuthPatient>
        {withPatientDashboardLayout(<PatientHome />)}
      </RequireAuthPatient>
    ),
  },
  {
    path: "/patient/consultations",
    element: (
      <RequireAuthPatient>
        {withPatientDashboardLayout(<PatientConsultations />)}
      </RequireAuthPatient>
    ),
  },
  {
    path: "/patient/dossier",
    element: (
      <RequireAuthPatient>
        {withPatientDashboardLayout(<PatientMedicalFile />)}
      </RequireAuthPatient>
    ),
  },
  {
    path: "/patient/ordonnances",
    element: (
      <RequireAuthPatient>
        {withPatientDashboardLayout(<PatientPrescriptions />)}
      </RequireAuthPatient>
    ),
  },
  {
    path: "/patient/vaccinations",
    element: (
      <RequireAuthPatient>
        {withPatientDashboardLayout(<PatientVaccinations />)}
      </RequireAuthPatient>
    ),
  },
  {
    path: "/patient/sante",
    element: (
      <RequireAuthPatient>
        {withPatientDashboardLayout(<PatientMonEspaceSante />)}
      </RequireAuthPatient>
    ),
  },
  {
    path: "/patient/verification-identite",
    element: (
      <RequireAuthPatient>
        {withPatientDashboardLayout(<PatientIdentityVerification />)}
      </RequireAuthPatient>
    ),
  },
  {
    path: "/patient/enfants/nouveau",
    element: (
      <RequireAuthPatient>
        {withPatientDashboardLayout(<PatientAjouterEnfant />)}
      </RequireAuthPatient>
    ),
  },
  {
    path: "/patient/contacts-surete",
    element: (
      <RequireAuthPatient>
        {withPatientDashboardLayout(<PatientContactsSurete />)}
      </RequireAuthPatient>
    ),
  },
  { path: "/patient/contacts-surete/confirmer", element: <ConfirmerContactSurete /> },

  { path: "/ministere/connexion", element: <MinistryLogin /> },
  { path: "/ministere/dashboard", element: <MinistryDashboard /> },
  { path: "/ministere/communique", element: <MinistryCommunique /> },

  { path: "/professionnel/connexion", element: <ProLogin /> },
  { path: "/professionnel/connexion/code", element: <ProVerificationCode /> },
  { path: "/professionnel/mot-de-passe/oubli", element: <ProForgotPassword /> },
  { path: "/professionnel/mot-de-passe/code", element: <ProVerificationCode /> },
  { path: "/professionnel/mot-de-passe/nouveau", element: <ProNewPassword /> },

  { path: "/professionnel/inscription/informations-1", element: <ProSignupInfo1 /> },
  { path: "/professionnel/inscription/informations-2", element: <ProSignupInfo2 /> },
  { path: "/professionnel/inscription/identifiants", element: <ProSignupCredentials /> },
  { path: "/professionnel/inscription/etablissements", element: <ProSignupEtablissements /> },
  { path: "/professionnel/inscription/document", element: <ProSignupDocument /> },
  { path: "/professionnel/inscription/succes", element: <ProSignupSuccess /> },

  { path: "/etablissement/connexion", element: <EtablissementLogin /> },
  { path: "/etablissement/connexion/code", element: <EtablissementLoginCode /> },
  { path: "/etablissement/mot-de-passe/oubli", element: <EtablissementForgotPassword /> },
  { path: "/etablissement/mot-de-passe/code", element: <EtablissementCode /> },
  { path: "/etablissement/mot-de-passe/nouveau", element: <EtablissementNewPassword /> },
  { path: "/etablissement/inscription/recherche", element: <EtablissementSignupSearch /> },
  { path: "/etablissement/inscription/informations", element: <EtablissementSignupInfo /> },
  { path: "/etablissement/inscription/identifiants", element: <EtablissementSignupCredentials /> },
  { path: "/etablissement/inscription/documents", element: <EtablissementSignupDocuments /> },
  { path: "/etablissement/inscription/succes", element: <EtablissementSignupSuccess /> },

  {
    path: "/etablissement/dashboard",
    element: (
      <RequireAuthEtablissement>
        <Navigate to="/etablissement/dashboard/patients" replace />
      </RequireAuthEtablissement>
    ),
  },
  {
    path: "/etablissement/dashboard/patients",
    element: (
      <RequireAuthEtablissement>
        {withEtablissementDashboardLayout(<EtablissementPatients />)}
      </RequireAuthEtablissement>
    ),
  },
  {
    path: "/etablissement/dashboard/patients/nouveau",
    element: (
      <RequireAuthEtablissement>
        {withEtablissementDashboardLayout(<EtablissementAddPatient />)}
      </RequireAuthEtablissement>
    ),
  },
  {
    path: "/etablissement/dashboard/patients/:nip",
    element: (
      <RequireAuthEtablissement>
        {withEtablissementDashboardLayout(<EtablissementPatientDetail />)}
      </RequireAuthEtablissement>
    ),
  },
  {
    path: "/etablissement/dashboard/lits",
    element: (
      <RequireAuthEtablissement>
        {withEtablissementDashboardLayout(<EtablissementBeds />)}
      </RequireAuthEtablissement>
    ),
  },
  {
    path: "/etablissement/dashboard/sangs",
    element: (
      <RequireAuthEtablissement>
        {withEtablissementDashboardLayout(<EtablissementBlood />)}
      </RequireAuthEtablissement>
    ),
  },
  {
    path: "/etablissement/dashboard/produits",
    element: (
      <RequireAuthEtablissement>
        {withEtablissementDashboardLayout(<EtablissementProducts />)}
      </RequireAuthEtablissement>
    ),
  },
  {
    path: "/etablissement/dashboard/statistiques",
    element: (
      <RequireAuthEtablissement>
        {withEtablissementDashboardLayout(<EtablissementStatistiques />)}
      </RequireAuthEtablissement>
    ),
  },
  {
    path: "/etablissement/dashboard/personnel",
    element: (
      <RequireAuthEtablissement>
        {withEtablissementDashboardLayout(<EtablissementPersonnel />)}
      </RequireAuthEtablissement>
    ),
  },
  {
    path: "/etablissement/dashboard/consultations",
    element: (
      <RequireAuthEtablissement>
        {withEtablissementDashboardLayout(<EtablissementConsultations />)}
      </RequireAuthEtablissement>
    ),
  },
  {
    path: "/etablissement/dashboard/verification-identite",
    element: (
      <RequireAuthEtablissement>
        {withEtablissementDashboardLayout(<EtablissementIdentityVerification />)}
      </RequireAuthEtablissement>
    ),
  },

  {
    path: "/pro/dashboard",
    element: <Navigate to="/pro/dashboard/mon-activite" replace />,
  },
  {
    path: "/pro/dashboard/patients",
    element: (
      <RequireAuthProfessional>
        <ProDashboardLayout><ProPatients /></ProDashboardLayout>
      </RequireAuthProfessional>
    ),
  },
  {
    path: "/pro/dashboard/diagnostic-rapide",
    element: (
      <RequireAuthProfessional>
        <ProDashboardLayout>
          <ProQuickDiagnostic />
        </ProDashboardLayout>
      </RequireAuthProfessional>
    ),
  },
  {
    path: "/pro/dashboard/patients/:id",
    element: (
      <RequireAuthProfessional>
        <ProDashboardLayout><ProPatientDetail /></ProDashboardLayout>
      </RequireAuthProfessional>
    ),
  },
  {
    path: "/pro/dashboard/profil",
    element: (
      <RequireAuthProfessional>
        <ProDashboardLayout><ProProfile /></ProDashboardLayout>
      </RequireAuthProfessional>
    ),
  },
  {
    path: "/pro/dashboard/mon-activite",
    element: (
      <RequireAuthProfessional>
        <ProDashboardLayout><ProMonActivite /></ProDashboardLayout>
      </RequireAuthProfessional>
    ),
  },
  {
    path: "/pro/dashboard/consultations-assignees",
    element: (
      <RequireAuthProfessional>
        <ProDashboardLayout><ProMesConsultationsAssignees /></ProDashboardLayout>
      </RequireAuthProfessional>
    ),
  },
  {
    path: "/pro/dashboard/verification-identite",
    element: (
      <RequireAuthProfessional>
        <ProDashboardLayout><ProIdentityVerification /></ProDashboardLayout>
      </RequireAuthProfessional>
    ),
  },
];

export default routesConfig;
